import { Tabs, TabsProps, Row, Col, Button, Form, Breadcrumb } from "antd";
import Customer from "./GeneralSetting";
import Company from "./CompanyInformation";
import Billing from "./BillingSettings";
import { useState } from "react";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { useTranslation } from "react-i18next";
import { settingsType } from "./settingsType";
import { getSettingsById } from "../../api/setting";
import { useEffect } from "react";
import { useMutation, useQuery } from "react-query";
import { getCurrencyDropdown } from "../../api/currency";
import { Link, useNavigate } from "react-router-dom";
import PreviousButton from "../UI/PreviousButton/previousbutton";
import NextButton from "../UI/NextButton/nextbutton";
import { getCountriesDropdown } from "../../api/countries";
import Title from "../UI/Title/Title";
import { Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";

export interface Option {
  value: string;
  id: number;
}



const Settings = () => {
  const [settings, setSettings] = useState<settingsType | undefined>();
  const [form] = Form.useForm();
  const [t] = useTranslation("common");
  const [key, setKey] = useState("1");
  const navigate = useNavigate();

  const [formatedCountry, setFormatedCountry] = useState<Option[]>();
  const [countries, setCountries] = useState<any>(null)

  const { isLoading: loadingCountries } = useQuery("countries", getCountriesDropdown, {
    refetchOnWindowFocus: false,
    onSuccess: (res: any) => {
      setCountries(res.data)
      setFormatedCountry(
        res.data?.map((country: any) => {
          return {
            value: country.id,
            label: (
              <>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img style={{ width: 15, height: 15, marginRight: '0.3rem' }} src={`/flags/${country.abbreviation}.svg`} />
                  {country.areaCode}
                </div>
              </>
            ),
          };
        })
      );
    },
  });
  const [formatedCurrency, setFormatedCurrency] = useState<{}[]>();
  const { isLoading: loadingCurrency } = useQuery("currencies", getCurrencyDropdown, {
    refetchOnWindowFocus: false,
    onSuccess: (res) => {
      setFormatedCurrency(
        res.data?.map((curr: any) => {
          return { value: curr.id, label: curr.name };
        })
      );
    },
  });

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: `${t("general-settings")}`,
      children: <Customer settings={settings} countries={countries} loadingCountries={loadingCountries} />,
    },
    {
      key: "2",
      label: `${t("billing-settings")}`,
      children: <Billing settings={settings} formatedCurrency={formatedCurrency} loadingCurrency={loadingCurrency}/>,
    },
    {
      key: "3",
      label: `${t("company-information")}`,
      children: <Company formatedCountry={formatedCountry} settings={settings} />,
    },
  ];
  const getSettingsMutation = useMutation("getSettings", getSettingsById, {
    onSuccess: (res) => {
      setSettings(res.data);
    },
  });

  useEffect(() => {
    getSettingsMutation.mutate();
  }, []);
  useEffect(() => {
    form.setFieldsValue({
      curId: settings?.curr?.id,
      companyname: settings?.companyName,
      phonenumber: settings?.companyPhoneNumber,
      email: settings?.companyEmail,
      defaultMode: settings?.defaultMode,
      currency:
        settings?.curr?.id ||
        JSON.parse(localStorage.getItem("mainCurrency") || "")?.id,
      Preferredlanguage: settings?.defaultLanguage,
    });
  }, [settings, form]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeTabLabel, setActiveTabLabel] = useState(items[0].label);

  const updateActiveTabLabel = (activeKey: string) => {
    const activeItem = items.find((item) => item.key === activeKey);
    if (activeItem) {
      setActiveTabLabel(activeItem.label);
    } else {
      setActiveTabLabel("");
    }
  };

  const onChange = (key: string) => {
    setKey(key);
    updateActiveTabLabel(key);
  };

  const handleNext = () => {
    const nextKey = (parseInt(key) + 1).toString();
    setKey(nextKey);
    updateActiveTabLabel(nextKey);
  };

  const handlePrevious = () => {
    const previousKey = (parseInt(key) - 1).toString();
    setKey(previousKey);
    updateActiveTabLabel(previousKey);
  };

  return (
    <>
      <Row gutter={[0, 10]}>
        <Col offset={1} span={20}>

          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("settings")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">{activeTabLabel}</span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("settings")}`} />
        </Col>
        <Row style={{ minHeight: "70vh" }}>
          <Col offset={1} span={22}>
            <Form layout="vertical" form={form} id="settingsform">
              <Tabs
                className="ant-tab"
                defaultActiveKey="1"
                activeKey={key}
                items={items}
                onChange={onChange}
              />
            </Form>
          </Col>
        </Row>
        <Col offset={1} span={4}>
          <CancelBtn data-testid="cancel-btn" />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <PreviousButton
            onClick={() => handlePrevious()}
            disabled={key === "1"}
            data-testid="previous-button"
          />
          {key !== "3" ? (
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <NextButton onClick={() => handleNext()} disabled={""} />
            </Col>
          ) : (
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <div>
                <Button
                  type="primary"
                  className="btn"
                  size="large"
                  form="settingsform"
                  htmlType="submit"
                  onClick={() => {
                    setIsModalVisible(true);
                  }}
                >
                  {t("save")}
                </Button>
                <Modal
                  centered
                  visible={isModalVisible}
                  onOk={() => {
                    navigate(`/main`);
                  }}
                  onCancel={() => setIsModalVisible(false)}
                  open={isModalVisible}
                  okButtonProps={{
                    style: {
                      background: "#1677FF",
                      color: "#fff",
                    },
                  }}
                  maskClosable={false}
                  cancelButtonProps={{
                    style: {
                      color: "#1677FF",
                      border: "1px solid #1677FF",
                      marginInlineEnd: "auto",
                    },
                  }}
                  closable={false}
                  okText="Confirm"
                >
                  <Row>
                    <Col span={3}>
                      <ExclamationCircleFilled
                        style={{
                          color: "#FFBC39",
                          fontSize: "45px",
                          marginRight: "12px",
                          marginTop: "22px",
                        }}
                      />
                    </Col>

                    <Col span={19}>
                      <Col
                        style={{
                          fontSize: "32px",
                          color: "#212121",
                        }}
                      >
                        {" "}
                        {t("Confirm Changes")}
                      </Col>
                      <Col
                        style={{
                          color: "#212121",
                          fontSize: "16px",
                        }}
                      >
                        please confirm saving changes to Settings
                      </Col>
                    </Col>
                  </Row>
                </Modal>
              </div>
            </Col>
          )}
        </Col>
      </Row>
    </>
  );
};
export default Settings;
